import type { Theme } from "../..";
import type { UseThemePrimitivesProps } from "./types";

import { filterThemePrimitivesByType } from "./utils";

/**
 * `useThemePrimitives()`
 *
 * This hook can be used to get a specific group of primitives from the given theme and subtheme.
 * If theme or subtheme are not specified, it will return primitives for all themes and subthemes.
 */
function useThemePrimitives(
	themeFile: Theme.GriddoTheme,
	props: UseThemePrimitivesProps,
) {
	const themes: Array<Theme.GlobalTheme | Theme.Theme> = [];
	const { global, primitive, subtheme } = props;

	if (global) {
		themes.push(themeFile.global);
	}

	if (props.theme) {
		const selectedTheme = themeFile.themes.find((t) => t.id === props.theme);
		selectedTheme && themes.push(selectedTheme);
	} else {
		themes.push(...themeFile.themes);
	}

	return filterThemePrimitivesByType(themes, primitive, subtheme);
}

export { useThemePrimitives };
